<!-- EDIFACT START -->
<div class="container container-fixed">

  <!--  column headers outside -->
  <div class="row">
    <div class="col-sm-6"><h2>Edifact</h2></div>
    <div class="col-sm-6"><h2>X12</h2></div>
  </div>

  <form #configurationForm="ngForm" name="configurationForm" novalidate>
    <div class="flex-row">
      <div class="item">
        <!--<h2>Edifact</h2>-->
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label>Identification</label>
              <select id="selectIdentificationTypeEdifact" name="selectIdentificationTypeEdifact" class="form-control" [disabled]="!isEditing" [ngModel]="$safeNavigationMigration(clonedEdiConfig?.PartnerIdentificationType)" (ngModelChange)="clonedEdiConfig.PartnerIdentificationType = $event">
                @for (partnerIdentificationType of partnerIdentificationTypes; track partnerIdentificationType) {
                  <option [ngValue]="partnerIdentificationType">({{partnerIdentificationType.IdentificationType.Name}}) {{partnerIdentificationType.Value}}</option>
                }
              </select>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>Qualifier</label>
              <input id="inputQualifierEdifact" name="inputQualifierEdifact" type="text" class="form-control" [readonly]="!isEditing" [ngModel]="$safeNavigationMigration(clonedEdiConfig?.Qualifier)" maxlength="50" (ngModelChange)="clonedEdiConfig.Qualifier = $event" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>
                Comp. Elem.Sep
                <button type="button" class="btn btn-icon btn-tooltip" ngbTooltip="Component Element Seperator" triggers="click:blur">
                  <ep-svg-icon icon="info"></ep-svg-icon>
                </button>
              </label>
              <input type="text" name="inputComponentElementSeparatorEdifact" class="form-control" [readonly]="!isEditing" [ngModel]="$safeNavigationMigration(clonedEdiConfig?.ComponentElementSeparator)" (ngModelChange)="clonedEdiConfig.ComponentElementSeparator = $event" maxlength="2" />
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label>Decimal Mark</label>
              <input id="inputDecimalMarkEdifact" name="inputDecimalMarkEdifact" type="text" class="form-control" [readonly]="!isEditing" [ngModel]="$safeNavigationMigration(clonedEdiConfig?.DecimalMark)" (ngModelChange)="clonedEdiConfig.DecimalMark = $event" maxlength="1" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>Segment Terminator</label>
              <input type="text" class="form-control" name="inputSegmentTerminatorEdifact" [readonly]="!isEditing" [ngModel]="$safeNavigationMigration(clonedEdiConfig?.SegmentTerminator)" (ngModelChange)="clonedEdiConfig.SegmentTerminator = $event" maxlength="2" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>Application Reference</label>
              <input type="text" class="form-control" name="inputApplicationReferenceEdifact" [readonly]="!isEditing" [ngModel]="$safeNavigationMigration(clonedEdiConfig?.ApplicationReference)" (ngModelChange)="clonedEdiConfig.ApplicationReference = $event" maxlength="50" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label>Priority Code</label>
              <select class="form-control" [disabled]="!isEditing" name="selectPriorityCodeEdifact" [ngModel]="$safeNavigationMigration(clonedEdiConfig?.PriorityCode)" (ngModelChange)="clonedEdiConfig.PriorityCode = $event">
                <option [ngValue]="null">None</option>
                @for (priorityCode of priorityCodes; track priorityCode) {
                  <option [ngValue]="priorityCode">{{priorityCode}}</option>
                }
              </select>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>Segment Suffix</label>
              <select id="selectSegmentSuffixEdifact" name="selectSegmentSuffixEdifact" class="form-control" [disabled]="!isEditing" [ngModel]="$safeNavigationMigration(clonedEdiConfig?.SegmentSuffix)" (ngModelChange)="clonedEdiConfig.SegmentSuffix = $event">
                @for (ediSegmentSuffix of ediSegmentSuffixes; track ediSegmentSuffix) {
                  <option [ngValue]="ediSegmentSuffix">{{ediSegmentSuffix.SegmentSuffixName}}</option>
                }
              </select>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <div class="control control-checkbox lg control-form-group">
                <label> Enable Una <input type="checkbox" name="inputEnableUnaEdifact" [disabled]="!isEditing" [ngModel]="$safeNavigationMigration(clonedEdiConfig?.EnableUna)" (ngModelChange)="clonedEdiConfig.EnableUna = $event" /><i></i></label>
              </div>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label>Element Seperator</label>
              <input type="text" class="form-control" name="inputElementSeparatorEdifact" [readonly]="!isEditing" [ngModel]="$safeNavigationMigration(clonedEdiConfig?.ElementSeparator)" (ngModelChange)="clonedEdiConfig.ElementSeparator = $event" maxlength="2" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>Release Character</label>
              <input type="text" class="form-control" name="inputReleaseCharacterEdifact" [readonly]="!isEditing" [ngModel]="$safeNavigationMigration(clonedEdiConfig?.ReleaseCharacter)" (ngModelChange)="clonedEdiConfig.ReleaseCharacter = $event" maxlength="2" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>Repetition Character</label>
              <input type="text" class="form-control" name="inputRepetitionCharacterEdifact" [readonly]="!isEditing" [ngModel]="$safeNavigationMigration(clonedEdiConfig?.RepetitionCharacter)" (ngModelChange)="clonedEdiConfig.RepetitionCharacter = $event" maxlength="1" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label>Password Qualifier</label><br />
              <select class="form-control" name="selectPasswordQualifierEdifact" [disabled]="!isEditing" [ngModel]="$safeNavigationMigration(clonedEdiConfig?.PasswordQualifier)" (ngModelChange)="clonedEdiConfig.PasswordQualifier = $event">
                <option [ngValue]="null">None</option>
                @for (passwordQualifier of passwordQualifiers; track passwordQualifier) {
                  <option [ngValue]="passwordQualifier">{{passwordQualifier}}</option>
                }
              </select>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>Password</label>
              <input type="text" class="form-control" name="inputPasswordEdifact" [readonly]="!isEditing" [ngModel]="$safeNavigationMigration(clonedEdiConfig?.Password)" (ngModelChange)="clonedEdiConfig.Password = $event" maxlength="50" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label>Edifact Character Set</label>
              <select class="form-control" name="selectCharacterSetEdifact" [disabled]="!isEditing" [ngModel]="$safeNavigationMigration(clonedEdiConfig?.CharacterSet)" (ngModelChange)="clonedEdiConfig.CharacterSet = $event" id="selectEdifactCharacterSetEdifact">
                @for (edifactCharacterSet of edifactCharacterSets; track edifactCharacterSet) {
                  <option [ngValue]="edifactCharacterSet">{{edifactCharacterSet.Identifier}}</option>
                }
              </select>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>Edifact Syntax</label>
              <select class="form-control" name="selectSyntaxEdifact" [disabled]="!isEditing" [ngModel]="$safeNavigationMigration(clonedEdiConfig?.Syntax)" (ngModelChange)="clonedEdiConfig.Syntax = $event" id="selectEdifactSyntaxEdifact">
                @for (edifactSyntax of edifactSyntaxes; track edifactSyntax) {
                  <option [ngValue]="edifactSyntax">{{edifactSyntax.Version}}</option>
                }
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <!--<h2>X12</h2>-->
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label>Identification</label>
              <select class="form-control" name="selectPartnerIdentificationTypeX12" [disabled]="!isEditing" [ngModel]="$safeNavigationMigration(clonedX12Config?.PartnerIdentificationType)" (ngModelChange)="clonedX12Config.PartnerIdentificationType = $event">
                @for (partnerIdentificationType of partnerIdentificationTypes; track partnerIdentificationType) {
                  <option [ngValue]="partnerIdentificationType">({{partnerIdentificationType.IdentificationType.Name}}) {{partnerIdentificationType.Value}}</option>
                }
              </select>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>Qualifier</label>
              <input type="text" name="inputQualifierX12" class="form-control" [readonly]="!isEditing" [ngModel]="$safeNavigationMigration(clonedX12Config?.Qualifier)" (ngModelChange)="clonedX12Config.Qualifier = $event" maxlength="50" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>Authorization Qualifier</label>
              <select class="form-control" name="selectAuthorizationQualifierX12" [disabled]="!isEditing" [ngModel]="$safeNavigationMigration(clonedX12Config?.AuthorizationQualifier)" (ngModelChange)="clonedX12Config.AuthorizationQualifier = $event">
                @for (authorizationQualifier of authorizationQualifiers; track authorizationQualifier) {
                  <option [ngValue]="authorizationQualifier">{{authorizationQualifier.DisplayName}}</option>
                }
              </select>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label>
                Author. Quali. Value
                <button type="button" class="btn btn-icon btn-tooltip" ngbTooltip="Authorization Qualifier Value" triggers="click:blur">
                  <ep-svg-icon icon="info"></ep-svg-icon>
                </button>
              </label>
              <input type="text" name="inputAuthorizationValueX12" class="form-control" [readonly]="!isEditing" [ngModel]="$safeNavigationMigration(clonedX12Config?.AuthorizationValue)" (ngModelChange)="clonedX12Config.AuthorizationValue = $event" maxlength="500" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>Security Qualifier</label>
              <select class="form-control" name="selectSecurityQualifierX12" [disabled]="!isEditing" [ngModel]="$safeNavigationMigration(clonedX12Config?.SecurityQualifier)" (ngModelChange)="clonedX12Config.SecurityQualifier = $event">
                @for (securityQualifier of securityQualifiers; track securityQualifier) {
                  <option [ngValue]="securityQualifier">{{securityQualifier.DisplayName}}</option>
                }
              </select>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>Security Qualifier Value</label>
              <input type="text" class="form-control" name="inputSecurityValueX12" [readonly]="!isEditing" [ngModel]="$safeNavigationMigration(clonedX12Config?.SecurityValue)" (ngModelChange)="clonedX12Config.SecurityValue = $event" maxlength="500" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label>Segment Suffix</label>
              <select class="form-control" name="selectEdifactSegmentSuffixX12" [disabled]="!isEditing" [ngModel]="$safeNavigationMigration(clonedX12Config?.EdifactSegmentSuffix)" (ngModelChange)="clonedX12Config.EdifactSegmentSuffix = $event">
                @for (ediSegmentSuffix of ediSegmentSuffixes; track ediSegmentSuffix) {
                  <option [ngValue]="ediSegmentSuffix">{{ediSegmentSuffix.SegmentSuffixName}}</option>
                }
              </select>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>Character Set</label>
              <select class="form-control" name="selectCharacterSetX12" [disabled]="!isEditing" [ngModel]="$safeNavigationMigration(clonedX12Config?.CharacterSet)" (ngModelChange)="clonedX12Config.CharacterSet = $event">
                @for (characterSet of characterSets; track characterSet) {
                  <option [ngValue]="characterSet">{{characterSet.Name}}</option>
                }
              </select>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>
                Comp. Elem.Sep
                <button type="button" class="btn btn-icon btn-tooltip" ngbTooltip="Component Element Seperator" triggers="click:blur">
                  <ep-svg-icon icon="info"></ep-svg-icon>
                </button>
              </label>
              <input type="text" class="form-control" name="inputComponentElementSeparatorX12" [readonly]="!isEditing" [ngModel]="$safeNavigationMigration(clonedX12Config?.ComponentElementSeparator)" (ngModelChange)="clonedX12Config.ComponentElementSeparator = $event" maxlength="2" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label>Data Element</label>
              <input type="text" class="form-control" name="inputDataElementX12" [readonly]="!isEditing" [ngModel]="$safeNavigationMigration(clonedX12Config?.DataElement)" (ngModelChange)="clonedX12Config.DataElement = $event" maxlength="2" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>Segment Terminator</label>
              <input type="text" class="form-control" name="inputSegmentTerminatorX12" [readonly]="!isEditing" [ngModel]="$safeNavigationMigration(clonedX12Config?.SegmentTerminator)" (ngModelChange)="clonedX12Config.SegmentTerminator = $event" maxlength="2" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>Replacement Character</label>
              <input type="text" class="form-control" name="inputReplacementCharacterX12" [readonly]="!isEditing" [ngModel]="$safeNavigationMigration(clonedX12Config?.ReplacementCharacter)" (ngModelChange)="clonedX12Config.ReplacementCharacter = $event" maxlength="2" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- INTERCHANGE NUMBERS -->

    <h2>Interchange Numbers</h2>
    <div class="row">
      <div class="col-sm-3">
        <div class="form-group">
          <div class="form-group">
            <div class="control control-checkbox lg control-form-group">
              <label>Preserve on Resend<input type="checkbox" [disabled]="!isEditing" name="InterchangeNumber" [ngModel]="$safeNavigationMigration(clonedEdiConfig?.PreserveInterchangeNumberOnResend)" (ngModelChange)="clonedEdiConfig.PreserveInterchangeNumberOnResend = $event" /><i></i></label>
            </div>
          </div>

        </div>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
          <div class="control control-checkbox lg control-form-group">
            <label>Use Partner Specific Interchange Number<input type="checkbox" name="userPartnerSpecific" [disabled]="!isEditing" [ngModel]="$safeNavigationMigration(clonedEdiConfig?.UsePartnerSpecificInterchangeNumber)" (ngModelChange)="clonedEdiConfig.UsePartnerSpecificInterchangeNumber = $event" /><i></i></label>
          </div>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
          <label>Current Specific Interchange Number</label>
          <input type="text" name="CurrentSpecificInterchangeNo" #CurrentSpecificInterchangeNo="ngModel" required pattern="\d*" class="form-control" [disabled]="!isEditing ||  !clonedEdiConfig?.UsePartnerSpecificInterchangeNumber" [ngModel]="$safeNavigationMigration(clonedEdiConfig?.NewSequenceValue)" (ngModelChange)="clonedEdiConfig.NewSequenceValue = $event" />
          @if (CurrentSpecificInterchangeNo.errors && (CurrentSpecificInterchangeNo.dirty || CurrentSpecificInterchangeNo.touched)) {
            <div>
              @if (CurrentSpecificInterchangeNo.errors.required) {
                <div class="error">Please enter the interchange number</div>
              }
              @if (CurrentSpecificInterchangeNo.errors.pattern) {
                <div class="error">Please enter number only</div>
              }
            </div>
          }
        </div>
      </div>
    </div>
    <!-- INTERCHANGE NUMBERS END-->

    <div class="row">
      <div class="col-sm-12">
        @if (!isEditing) {
          <div>
            <button id="btnEditEdiConfigurations" class="btn btn-primary" type="button" (click)="edit()" *bizPermissionRequired="['Partner_Action_EdiConfigurationsEdit', 'Partner_Action_InternalPartner']; type:'And'; evaluator:evaluatePermissions; trigger: selectedPartner">Edit</button>
          </div>
        }
        @if (isEditing) {
          <button id="btnSaveEdiConfigurations" class="btn btn-primary" type="button" (click)="configurationForm.valid && save()">Save</button>
        }
        @if (isEditing) {
          <button id="btCancelEdiConfigurations" class="btn btn-link" type="button" (click)="cancel()">Cancel</button>
        }
      </div>
    </div>
  </form>
</div>
